import {Component, Injector, Input} from '@angular/core';
import {ColumnType, GeneralListComponent} from "../../shared/general-list/general-list.component";
import {LogsService} from "../../logs/logs.service";

@Component({
    selector: 'app-device-log',
    templateUrl: '../../shared/general-list/general-list.component.html',
    standalone: false
})
export class DeviceLogComponent extends GeneralListComponent {

  @Input() deviceID: number;

  constructor(
    private logService: LogsService,
    injector: Injector,
  ) {
    super(injector);

    this.title = this.logService.getTranslation("LOGS");
    this.smallbar = true;

    this.columns = [
      {id: 'id',label: "ID", type: ColumnType.Simple},
      {id: 'message',label: this.logService.getTranslation("MESSAGE"), type: ColumnType.Simple},
      {id: 'level',label: this.logService.getTranslation("LEVEL"), type: ColumnType.Simple},
      {id: 'classname',label: this.logService.getTranslation("CLASS"), type: ColumnType.Simple},
      {id: 'channel',label: this.logService.getTranslation("ENTITY_ID"), type: ColumnType.Simple},
      {id: 'modified',label: this.logService.getTranslation("MODIFIED"), type: ColumnType.Simple},
      {id: 'modifiedBy',label: this.logService.getTranslation("MODIFIEDBY"), type: ColumnType.Simple},
    ];
  }

  fetchItems() {
    if (this.deviceID) {
      this.logService.getDeviceLogs(this.deviceID).subscribe((resp:any) => {
        if (resp && resp.length) {
          this.items = resp;
          this.dataSource.data = this.items;
        }
      })
    }
  }

}
